import { useCallback } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { useUserStore } from '@/stores/user';

const isAuthDisabled = import.meta.env.VITE_DISABLE_AUTH === 'true';

/**
 * Hook to handle logout functionality.
 * Clears user state and signs out of Okta.
 */
export const useLogout = () => {
  const oktaAuthContext = useOktaAuth();
  const resetUser = useUserStore((state) => state.reset);

  const logout = useCallback(async () => {
    resetUser();
    const oktaAuth = oktaAuthContext?.oktaAuth;
    if (!isAuthDisabled && oktaAuth) {
      await oktaAuth.signOut();
    } else {
      window.location.href = '/';
    }
  }, [oktaAuthContext, resetUser]);

  return logout;
};
